import React from 'react';
import { INSTAGRAM } from '../config/social';

export default function InstagramSection() {
  const avatarSrc = `${process.env.PUBLIC_URL}/assets/instagram-avatar.jpg`;
  return (
    <section style={{
      background: 'var(--color-surface-alt)',
      padding: '60px 32px',
      textAlign: 'center',
    }}>
      <div style={{ maxWidth: 500, margin: '0 auto' }}>

        {/* Avatar */}
        <img
          src={avatarSrc}
          alt={INSTAGRAM.handle}
          style={{
            width: 96,
            height: 96,
            borderRadius: '50%',
            objectFit: 'cover',
            margin: '0 auto 16px',
            display: 'block',
            border: '3px solid #fff',
            boxShadow: '0 2px 12px rgba(0,0,0,0.12)',
          }}
        />

        <h3 style={{
          fontFamily: 'var(--font-display)',
          fontSize: 22,
          fontWeight: 400,
          color: 'var(--color-text)',
          marginBottom: 8,
        }}>
          {INSTAGRAM.handle}
        </h3>

        <p style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--color-muted)',
          fontSize: 13,
          lineHeight: 1.7,
          marginBottom: 24,
        }}>
          {INSTAGRAM.bio}
        </p>


         <a href={INSTAGRAM.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            background: 'var(--color-accent)',
            color: '#fff',
            padding: '12px 32px',
            fontSize: 11,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontFamily: 'var(--font-body)',
            borderRadius: 'var(--border-radius)',
            transition: 'background 0.2s',
          }}
          onMouseEnter={e => e.target.style.background = 'var(--color-accent-hover)'}
          onMouseLeave={e => e.target.style.background = 'var(--color-accent)'}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <defs>
              <linearGradient id="instagramGradientButton" x1="0%" y1="100%" x2="100%" y2="0%">
                <stop offset="0%" style={{ stopColor: '#FD5949', stopOpacity: 1 }} />
                <stop offset="50%" style={{ stopColor: '#D6249F', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#285AEB', stopOpacity: 1 }} />
              </linearGradient>
            </defs>
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke="url(#instagramGradientButton)"></rect>
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" stroke="url(#instagramGradientButton)"></path>
            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" stroke="url(#instagramGradientButton)"></line>
          </svg>
          Follow on Instagram
        </a>

      </div>
    </section>
  );
}